import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { DedicatedChannelsFilter } from '@components/Capacity/DedicatedChannels/DedicatedChannelsFilter';
import { DedicatedChannelsTable } from '@components/Capacity/DedicatedChannels/DedicatedChannelsTable';
import { capacityApi } from '@reducers/capacity';

export const DedicatedChannels = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <Formik
      enableReinitialize
      initialValues={{
        country: searchParams.get('country') || '',
        plan: searchParams.get('plan') || '',
        did: searchParams.get('did') || '',
      }}
      onSubmit={() => {}}
    >
      <Form as={Row}>
        <Col md={3}>
          <DedicatedChannelsFilter
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
        <Col md={9}>
          <DedicatedChannelsTable
            useData={capacityApi.useGetDedicatedChannelsDidsQuery}
            searchParams={searchParams}
          />
        </Col>
      </Form>
    </Formik>
  );
};
